<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="High Function Sports Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first">
            <sub-product tit="High Function Sports Line" file="sports">
               방습성/발수성, 쿨링/히팅 기능으로 소비자의 건강한 삶을 도와줍니다. 기능성 실과 니팅 구조로 다양한 기능성을 구체화 시킵니다. 소비자의 삶을 풍요롭게 하는 다양한 아이템을 만나보세요.
            </sub-product>
        </sub-section>

        <!-- <sub-section class="page-section--last">
            <v-img src="/images/sub/product/sports/sports-img.jpg" class="w-100"></v-img>
        </sub-section> -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped></style>
